import { Textarea } from './Textarea';

export type { TextareaProps } from './types';

export default Textarea;
